import React, { useState } from "react";

export const GeneralContext = React.createContext();

export const GeneralProvider = (props) => {
  const [newsId, setNewsId] = useState(null);
  const [guideId, setGuideId] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [showDetail, setShowDetail] = useState(null);
  const [productCtx, setProductCtx] = useState(null);
  const [departementCtx, setDepartementCtx] = useState(null);
  const [A2F, setA2F] = useState(null);
  const [plugTotHarga, setPlugTotHarga] = useState([]);

  const showToast = (showStatus, detail) => {
    setShowAlert(showStatus);
    setShowDetail(detail);
  };

  const showError = (error) => {
    let arrErr = [];
    if (Array.isArray(error)) {
      arrErr = error.map((val, i) => {
        const time = i * 100;
        return { severity: "error", summary: "Error", detail: val, life: 3000 + time };
      });
      showToast("array", arrErr);
      return;
    }
    //non array
    showToast("error", error);
  };

  const value = {
    newsId,
    setNewsId,
    guideId,
    setGuideId,
    showAlert,
    setShowAlert,
    showDetail,
    showToast,
    showError,
    productCtx,
    setProductCtx,
    departementCtx,
    setDepartementCtx,
    A2F,
    setA2F,
    plugTotHarga,
    setPlugTotHarga,
  };

  return <GeneralContext.Provider value={value}>{props.children}</GeneralContext.Provider>;
};
